<template>
    <v-container fill-height class="align-start">
        <v-row no-gutters class="align-self-center">
            <v-col>
                <loading-overlay :loading="loading"></loading-overlay>
                <v-row class="justify-space-between pa-4 align-center" no-gutters>
                    <v-col>
                        <v-row class="align-center" no-gutters>
                            <v-col class="flex-grow-0">
                                <router-link to="/">
                                    <v-img
                                        alt="logo"
                                        src="/svg/logo.svg"
                                        class="align-self-start mb-1"
                                        width="125"
                                        contain
                                    ></v-img>
                                </router-link>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col class="text-right">
                        <p>
                            <span class="body-2 grey--text text--darken-1 d-none d-sm-inline-flex flex-wrap">Already have an account?</span>
                            <router-link :to="{ name: 'login' }">
                                <v-btn
                                    href="#"
                                    class="px-sm-12 ml-4"
                                    color="primary"
                                    outlined
                                    medium
                                >
                                    Sign in
                                </v-btn>
                            </router-link>
                        </p>
                    </v-col>
                </v-row>

                <template>
                    <v-stepper :value="step" class="mt-5">
                        <v-stepper-header>
                            <v-stepper-step @click="step = 1" editable step="1">Personal Information</v-stepper-step>

                            <v-divider></v-divider>

                            <v-stepper-step @click="step = 2" editable step="2">Account Information</v-stepper-step>

                            <v-divider></v-divider>

                            <v-stepper-step @click="step = 3" editable step="3">Other Information</v-stepper-step>
                        </v-stepper-header>

                        <v-stepper-items>
                            <v-stepper-content step="1">
                                <v-row class="py-12" align="center" justify="center" no-gutters>
                                    <v-col class="form">
                                        <h1 class="display-1 font-weight-bold primary--text mb-4">Personal Information</h1>
                                        <h2 class="subtitle-1 mb-8 notice red--text">
                                            <v-icon medium color="#F54E42">mdi-information</v-icon>
                                            Please enter name as it appears on government issued ID or Bank Statement
                                        </h2>

                                        <v-form class="text-center" validate-on-blur @keyup.enter="signUp" ref="form" @submit.prevent="signUp">
                                            <!-- Name -->
                                            <v-text-field
                                                aria-required
                                                required
                                                autofocus
                                                type="text"
                                                label="First Name"
                                                name="firstname"
                                                append-icon="mdi-account-outline"
                                                background-color="#f8f8fd"
                                                color="primary"
                                                v-model="user.firstname"
                                                v-validate="'required|name'"
                                                validate-on-blur
                                                outlined
                                                :error-messages="errors.first('firstname')"
                                            ></v-text-field>

                                            <v-text-field
                                                aria-required
                                                required
                                                autofocus
                                                type="text"
                                                label="Middle Name"
                                                name="middlename"
                                                append-icon="mdi-account-outline"
                                                background-color="#f8f8fd"
                                                color="primary"
                                                v-model="user.middlename"
                                                v-validate="'name'"
                                                validate-on-blur
                                                outlined
                                                :error-messages="errors.first('middlename')"
                                            ></v-text-field>

                                            <v-text-field
                                                aria-required
                                                required
                                                autofocus
                                                type="text"
                                                label="Last Name"
                                                name="lastname"
                                                append-icon="mdi-account-outline"
                                                background-color="#f8f8fd"
                                                color="primary"
                                                v-model="user.lastname"
                                                v-validate="'required|name'"
                                                validate-on-blur
                                                outlined
                                                :error-messages="errors.first('lastname')"
                                            ></v-text-field>

                                            <!-- DOB -->
                                            <dob-select
                                                v-model="user.dob"
                                                v-validate="'required|minimum-age'"
                                                name="date of birth"
                                                :error-messages="errors.first('date of birth')"
                                                validate-on-blur
                                                aria-required
                                                required
                                            />

                                            <v-radio-group
                                                label="Gender"
                                                v-model="user.gender"
                                                v-validate="'required'"
                                                name="gender"
                                                :error-messages="errors.first('gender')"
                                                validate-on-blur
                                                aria-required
                                                required
                                            >
                                                <v-radio
                                                    label="Male"
                                                    value="male"
                                                ></v-radio>
                                                <v-radio
                                                    label="Female"
                                                    value="Female"
                                                ></v-radio>
                                            </v-radio-group>

                                            <v-row no-gutters class="align-center">
                                                <v-col cols="12" class="py-0 text-left">
                                                    <v-checkbox
                                                        class="mt-0"
                                                        v-model="userAgreed"
                                                    >
                                                        <template v-slot:label>
                                                            <div>
                                                                I have read and agreed to Kaoshi's
                                                                <a
                                                                    href="https://www.kaoshinetwork.com/terms_of_service.html"
                                                                    target="_blank"
                                                                    class="primary--text font-weight-bold"
                                                                    @click.stop
                                                                >
                                                                    Terms of Service
                                                                </a>
                                                                and
                                                                <a
                                                                    href="https://www.kaoshinetwork.com/privacy_policy.html"
                                                                    target="_blank"
                                                                    @click.stop
                                                                    class="primary--text font-weight-bold"
                                                                >
                                                                    privacy policy
                                                                </a>
                                                            </div>
                                                        </template>
                                                    </v-checkbox>
                                                </v-col>

                                                <v-col class="text-right">
                                                    <v-btn
                                                        class="px-12"
                                                        :class="{ 'grey lighten-2': !userAgreed  }"
                                                        :color="userAgreed ? 'primary' : '#EEEEEE'"
                                                        type="submit"
                                                        block
                                                        :disabled="!userAgreed"
                                                        x-large
                                                    >
                                                        Next
                                                    </v-btn>
                                                </v-col>
                                            </v-row>
                                        </v-form>
                                    </v-col>
                                </v-row>
                            </v-stepper-content>

                            <v-stepper-content step="2">
                                <v-row class="py-12" align="center" justify="center" no-gutters>
                                    <v-col class="form">
                                        <h1 class="display-1 font-weight-bold primary--text mb-4">Login Credentials</h1>
                                        <h2 class="subtitle-1 mb-8">Create your account and conduct transactions on Kaoshi anytime</h2>

                                        <v-form validate-on-blur @keyup.enter="signUp" @submit.prevent="signUp" ref="form">
                                            <v-img
                                                    alt="logo"
                                                    src="/svg/login.svg"
                                                    class="align-self-start mx-auto my-0"
                                                    width="200"
                                                    contain
                                            ></v-img>

                                            <!-- Email -->
                                            <v-text-field
                                                class="mt-5"
                                                aria-required
                                                required
                                                type="text"
                                                label="Email"
                                                name="email"
                                                append-icon="mdi-email-outline"
                                                background-color="#f8f8fd"
                                                color="primary"
                                                outlined
                                                v-model="user.email"
                                                v-validate="'required|email'"
                                                validate-on-blur
                                                :error-messages="errors.first('email')"
                                            ></v-text-field>

                                            <!-- Password -->
                                            <v-text-field
                                                aria-required
                                                required
                                                v-model="user.password"
                                                v-validate="'required|verify-password'"
                                                validate-on-blur
                                                name="password"
                                                label="Password"
                                                hint="At least 6 characters"
                                                outlined
                                                background-color="#f8f8fd"
                                                color="primary"
                                                :append-icon=" passwordVisible ? 'mdi-eye-off' : 'mdi-eye' "
                                                @click:append="passwordVisible = !passwordVisible"
                                                color:append-icon="primary"
                                                :type="passwordVisible ? 'text' : 'password'"
                                                :error-messages="errors.first('password')"
                                            ></v-text-field>

                                            <v-row class="align-center">
                                                <v-col class="text-right">
                                                    <v-btn
                                                        class="px-12"
                                                        color="primary"
                                                        type="submit"
                                                        value="Join"
                                                        block
                                                        dark
                                                        depressed
                                                        x-large
                                                        append
                                                    >
                                                        Next
                                                    </v-btn>
                                                </v-col>

                                                <v-col
                                                    class="text-right"
                                                    cols="12"
                                                >
                                                    <v-btn
                                                        class="px-12"
                                                        block
                                                        text
                                                        x-large
                                                        @click="step = 1"
                                                    >
                                                        <v-icon left>
                                                            mdi-chevron-left
                                                        </v-icon>
                                                        Back
                                                    </v-btn>
                                                </v-col>
                                            </v-row>
                                        </v-form>
                                    </v-col>
                                </v-row>
                            </v-stepper-content>

                            <v-stepper-content step="3">
                                <v-row class="py-12" align="center" justify="center" no-gutters>
                                    <v-col class="form">
                                        <h1 class="display-1 font-weight-bold primary--text mb-4">Location of Bank</h1>
                                        <h2 class="subtitle-1 font-weight-bold mb-3">Select the location of the bank that will be used for your transaction</h2>

                                        <v-form validate-on-blur @keyup.enter="signUp" @submit.prevent="signUp" ref="form">
                                                <v-img
                                                    alt="logo"
                                                    src="/svg/world.svg"
                                                    class="align-self-start mx-auto my-0"
                                                    width="200"
                                                ></v-img>

                                            <p class="mt-3">
                                                Please note that a Kaoshi account can only be created for one country.
                                                If you have two banks in different countries, you would have to create
                                                a separate Kaoshi account for each country.
                                                Thank you
                                            </p>

                                            <v-autocomplete
                                                ref="purpose"
                                                v-model="purpose"
                                                v-validate="'required'"
                                                class="mt-5"
                                                aria-required
                                                required
                                                :error-messages="errors.first('purpose')"
                                                name="purpose"
                                                label="I want to"
                                                :items="[
                                                    'Send Money From',
                                                    'Receive Money In',
                                                ]"
                                                item-text="country"
                                                item-value="country"
                                                item-color="primary"
                                                color="primary"
                                                background-color="#f8f8fd"
                                                outlined
                                            />

                                            <v-autocomplete
                                                class="mt-5"
                                                ref="country"
                                                v-model="user.country"
                                                v-validate="'required'"
                                                aria-required
                                                required
                                                :error-messages="errors.first('country')"
                                                name="country"
                                                label="My Bank In"
                                                :items="countries"
                                                item-text="country"
                                                item-value="country"
                                                item-color="primary"
                                                color="primary"
                                                background-color="#f8f8fd"
                                                outlined
                                            >
                                                <!-- @focus.stop.once="showExamples = true" -->
                                                <template v-slot:append-outer>
                                                    <v-slide-x-reverse-transition mode="out-in">
                                                        <v-btn
                                                            class="mb-3"
                                                            icon
                                                            color="primary"
                                                            @click="showExamples = true"
                                                        >
                                                            <v-icon>mdi-information</v-icon>
                                                        </v-btn>
                                                    </v-slide-x-reverse-transition>
                                                </template>
                                            </v-autocomplete>

                                            <bank-location-examples :show.sync="showExamples" />

                                            <v-row class="align-center">
                                                <v-col
                                                    class="text-right"
                                                    cols="12"
                                                >
                                                    <v-btn
                                                        class="px-12"
                                                        color="primary"
                                                        type="submit"
                                                        value="Join"
                                                        block
                                                        dark
                                                        depressed
                                                        x-large
                                                        append
                                                    >
                                                        Sign up
                                                    </v-btn>
                                                </v-col>

                                                <v-col
                                                    class="text-right"
                                                    cols="12"
                                                >
                                                    <v-btn
                                                        class="px-12"
                                                        block
                                                        text
                                                        x-large
                                                        @click="step = 2"
                                                    >
                                                        <v-icon left>
                                                            mdi-chevron-left
                                                        </v-icon>
                                                        Back
                                                    </v-btn>
                                                </v-col>
                                            </v-row>
                                        </v-form>
                                    </v-col>
                                </v-row>
                            </v-stepper-content>
                        </v-stepper-items>
                    </v-stepper>
                </template>

            <v-row align="center" justify="center">
                <v-col class="form">
                        <v-row>
                            <v-col class="d-flex justify-space-between align-center">
                                <a class="caption primary--text font-weight-bold pa-4" href="#">Home</a>
                                <a
                                    href="https://www.kaoshinetwork.com/terms_of_service.html"
                                    class="caption primary--text font-weight-bold pa-4"
                                    target="_blank"
                                >
                                    Legal
                                </a>
                                <a
                                    href="https://www.kaoshinetwork.com/privacy_policy.html"
                                    target="_blank"
                                    class=" caption primary--text font-weight-bold pa-4"
                                >
                                    Privacy Policy
                                </a>
                            </v-col>
                        </v-row>
                        <p class="caption pb-6 mb-8 grey--text">&copy; {{ year }} Kaoshi. All rights reserved. Trademarks and brands are the property of their respective owners.</p>
                </v-col>
            </v-row>

            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import { mapActions } from 'vuex';

    import BankLocationExamples from './components/bank-location-examples.vue';
    import dobSelect from './components/dob-select.vue';

    export default {
        props: {
            email: {
                type: String,
                required: false,
                default: null,
            },
            token: {
                type: String,
                required: false,
                default: null,
            },
            referralCode: {
                type: String,
                required: false,
                default: null,
            },
        },
        data,
        components: {
            'dob-select': dobSelect,
            BankLocationExamples,
        },
        methods: getMethods(),
        mounted,
    };

    async function mounted() {
        const vm = this;
        this.logout({ redirectTo: null });
        window.dispatchEvent(new Event('positionBottomButton'));

        if (this.email && this.token) {
            await this.validateInvitationToken();
        } else if (this.referralCode) {
            await this.validateReferralCode();
        }

        Vue.backendApi()
            .countries()
            .list({ sort: 'order' })
            .then(success, error);

        function success(response) {
            Vue.set(vm, 'countries', response.data);
        }

        function error(error) {
            vm.$swal({
                type: 'error',
                title: 'Error loading countries',
                text: error,
            });
        }

        vm.addTrackingScripts();
    }

    function data() {
        return {
            year: Vue.moment().year(),
            passwordVisible: false,
            user: {
                firstname: null,
                middlename: null,
                lastname: null,
                gender: null,
                dob: null,
                country: '',
                email: this.email,
            },
            // confirm_password: '',
            loading: false,
            validationErrors: [],
            countries: [],
            dobOfBirthFieldType: 'text',
            step: 1,
            showExamples: false,
            userAgreed: false,
            purpose: null,
        };
    }

    function getMethods() {
        return {
            ...mapActions('auth', [
                'logout',
            ]),
            signUp,
            validateInvitationToken,
            validateReferralCode,
            async validateStep2() {
                const results = Promise.all([
                    this.$validator.validate('email'),
                    this.$validator.validate('password'),
                ]);

                const areValid = (await results).every((isValid) => isValid);
                return areValid;
            },
        };

        async function signUp(event) {
            const vm = this;
            var url = '/api/user/sign-up';

            const { firstname, lastname, middlename, dob, gender, email, password } = vm.user;
            if(firstname && lastname && dob && gender && vm.step === 1) {
                vm.step += 1;
                return false;
            } else if (vm.step === 2 && await this.validateStep2()) {
                vm.step += 1;
            }

            vm.$validator.validateAll().then(submitIfValid);

            function submitIfValid(formIsValid) {
                if (formIsValid) {
                    vm.loading = true;
                    const payload = {
                        ...vm.user,
                    };

                    if (vm.token) {
                        payload.token = vm.token;
                    }

                    if (vm.referralCode) {
                        payload.referral_code = vm.referralCode;
                    }

                    if (!payload.middlename) {
                      delete payload.middlename;
                    }
                    $.post(url, payload, handleSuccess).fail(handleError);
                }

                function handleSuccess(response) {
                    vm.loading = false;
                    vm.$swal({
                        type: 'success',
                        title: 'Account created',
                        text: 'Please check your email for instructions on verifying your account.',
                        preConfirm: () => {
                            vm.$router.push({name: 'user-confirmation-link-instructions'});
                        }
                    });
                }

                function handleError(response) {
                    vm.loading = false;
                    const { message: title } = response.responseJSON;
                    let text = '';

                    if (title === 'Wrong Email Address') {
                        text = 'The email address you entered does not match up with the invite link sent to you. Please enter the correct email linked to this sign up link.';
                    }
                    vm.$swal({
                        type: 'error',
                        title,
                        text,
                    });
                }
            }
        }

        function isDev() {
            return window.location.host === 'app-dev.kaoshinetwork.com';
        }

        /**
         * Validate invitation token with email
         */
        async function validateInvitationToken() {
            try {
                const {
                    email,
                } = this.user;

                // eslint-disable-next-line no-undef
                if (!isDev()) {
                    await Vue.backendApi()
                        .auth()
                        .validateInvitationToken({
                            email,
                            token: this.token,
                        });
                }

                return true;
            } catch (error) {
                this.$swal({
                    type: 'error',
                    title: 'Wrong Email Address',
                    text: 'The email address you entered does not match up with the invite link sent to you. Please enter the correct email linked to this sign up link.',
                    preConfirm: () => {
                        this.$router.push({
                            name: 'login',
                        });
                    },
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                });
                return false;
            }
        }

        /**
         * Validate referral code
         */
        async function validateReferralCode() {
            try {
                if (!isDev()) {
                    await Vue.backendApi()
                        .auth()
                        .validateReferralCode({ referral_code: this.referralCode });
                }

                return true;
            } catch (error) {
                this.$swal({
                    type: 'error',
                    title: 'Wrong Referral Code',
                    text: 'Please use the correct referral code to sign up.',
                    preConfirm: () => {
                        this.$router.push({
                            name: 'login',
                        });
                    },
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                });
                return false;
            }
        }
    }
</script>

<style scoped>
.slogan {
    color:#1a224e;
    font-size: .625rem!important;
    font-weight: 400;
    letter-spacing: .1666666667em!important;
    line-height: 1rem;
    font-family: Roboto,sans-serif!important;
    margin-top: .625rem;
    margin-left: 1rem;
    margin-bottom: 0;
    white-space: nowrap;
}

.form {
    text-align: center;
    max-width: 430px;
}

.theme--light.v-list-item .v-list-item__mask {
    color: unset;
    background: #ffeec7;
    padding: 0 2px;
}

/* Date picker */
.v-date-picker-title__year {
    margin-bottom: unset;
}

.v-date-picker-title {
    flex-direction: unset;
}

.v-date-picker-title__date {
    font-size: 14px;
}

@media screen and (min-width: 600px) {
    .absolute-top {
        position: fixed;
        top: 0px;
        left: 50%;
        transform: translateX(-50%);
        max-width: 1300px;
        width: 90%;
    }

    .notice {
        margin-left: -75px;
        width: 140%;
    }
}
</style>
